// extracted by mini-css-extract-plugin
module.exports = {"icon_container":"style_icon_container__3zwsj"};